export async function EspecialistaAdminCreate( 
    firstName,
        lastName,
        direccion,
        direccionNum,
        direccionPiso,
        direccionCiudad,
        direccionProvincia,
        direccionCp,
        email,
        telefono,
        telefonoSecundario,
        dni,
        username,
        password,
        especialidad,
        estadoUsuario,
        colegiado
    ) {
    console.log( 
        firstName,
        lastName,
        direccion,
        direccionNum,
        direccionPiso,
        direccionCiudad,
        direccionProvincia,
        direccionCp,
        email,
        telefono,
        telefonoSecundario,
        dni,
        username,
        password,
        especialidad,
        estadoUsuario,
        colegiado
    );
    const formData = {
        username: username,
        email: email,
        password: password,
        first_name: firstName,
        last_name: lastName,
        // roles: ['contributor'],
        roles: ['author'],
        meta: {
            especialidad: especialidad,
            telefono: telefono,
            dni: dni,
            colegiado: colegiado,
            direccion: direccion,
            direccion_num: direccionNum,
            direccion_piso: direccionPiso,
            direccion_ciudad: direccionCiudad,
            direccion_provincia: direccionProvincia,
            direccion_cp: direccionCp,
            telefono_familiar: telefonoSecundario,
            estado: estadoUsuario,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/users', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}